<script>
export default {
  name: 'FormGridBox',
  props: {
    headerText: {
      type: String,
      required: true,
    },
    detailsText: {
      type: [String, Number],
      required: true,
    },
  },
};
</script>

<template>
  <div class="form-grid-box">
    <div class="form-grid-box__container">
      <div class="form-grid-box__header">{{ headerText }}</div>
      <div class="form-grid-box__details">{{ detailsText }}</div>
    </div>
  </div>
</template>
